$(document).ready(function(){
  $('.custom_announcement_bar').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'linear'
  });
  
  

});
